import _classCallCheck from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _get from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/get.js";
import _getPrototypeOf from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import InAppMessage from "./in-app-message.js";
import { DOMUtils as de } from "../../util/dom-utils.js";
var SlideUpMessage = /*#__PURE__*/function (_InAppMessage) {
  _inherits(SlideUpMessage, _InAppMessage);
  var _super = _createSuper(SlideUpMessage);
  function SlideUpMessage(e, t, s, o, i, r, n, d, a, u, p, m, c, l, v, x, f, h, g, I, M, b, j, z) {
    var _this;
    _classCallCheck(this, SlideUpMessage);
    x = x || InAppMessage.th.Sh, v = v || InAppMessage.th.Rh, _this = _super.call(this, e, t = t || InAppMessage.TextAlignment.START, s, o, i, r, n, d, a, u, p, m, void 0, c, l, v, x, f, h, g, void 0, void 0, void 0, void 0, void 0, void 0, void 0, I, M, b, j, z), _this["do"] = InAppMessage.TextAlignment.START;
    return _this;
  }
  _createClass(SlideUpMessage, [{
    key: "Ve",
    value: function Ve() {
      return !1;
    }
  }, {
    key: "ho",
    value: function ho() {
      var e = document.createElement("span");
      return e.appendChild(document.createTextNode(this.message || "")), e;
    }
  }, {
    key: "Ah",
    value: function Ah(e) {
      var t = e.getElementsByClassName("ab-in-app-message")[0];
      de.Mo(t, !0, !0) || (this.slideFrom === InAppMessage.SlideFrom.TOP ? t.style.top = "0px" : t.style.bottom = "0px"), _get(_getPrototypeOf(SlideUpMessage.prototype), "Ah", this).call(this, e);
    }
  }, {
    key: "dt",
    value: function dt() {
      return _get(_getPrototypeOf(SlideUpMessage.prototype), "dt", this).call(this, SlideUpMessage.es);
    }
  }], [{
    key: "Xr",
    value: function Xr(e) {
      return new SlideUpMessage(e[InAppMessage.ss.Vr], e[InAppMessage.ss.Wr], e[InAppMessage.ss.Nh], e[InAppMessage.ss.xs], e[InAppMessage.ss.Yr], e[InAppMessage.ss.Zr], e[InAppMessage.ss.URI], e[InAppMessage.ss.ra], e[InAppMessage.ss.sa], e[InAppMessage.ss.ta], e[InAppMessage.ss.ia], e[InAppMessage.ss.ns], e[InAppMessage.ss.pa], e[InAppMessage.ss.ma], e[InAppMessage.ss.na], e[InAppMessage.ss.ua], e[InAppMessage.ss.ca], e[InAppMessage.ss.fa], e[InAppMessage.ss.da], e[InAppMessage.ss.wa], e[InAppMessage.ss.CSS], e[InAppMessage.ss.ya], e[InAppMessage.ss.LANGUAGE], e[InAppMessage.ss.ks]);
    }
  }]);
  return SlideUpMessage;
}(InAppMessage);
export { SlideUpMessage as default };
SlideUpMessage.es = InAppMessage.Ke.Kr;